"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVideoCodec = exports.setAudioCodec = exports.setDefaultCodecs = void 0;
function _setCodecs(transceiver, audio = 'audio/opus', video = 'video/VP8') {
    if (transceiver.sender.track == null) {
        return;
    }
    const { kind } = transceiver.sender.track;
    transceiver.direction = 'sendrecv';
    // firefox does not support getCapabilities or setCodecPreferences
    // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpTransceiver/setCodecPreferences
    if (!RTCRtpSender.getCapabilities)
        return;
    let capabilities = RTCRtpSender.getCapabilities(kind);
    if (!capabilities)
        return;
    let sendCodecs = capabilities.codecs;
    // let recvCodecs = RTCRtpReceiver.getCapabilities(kind).codecs;
    try {
        if (kind === 'audio') {
            sendCodecs = _preferCodec(sendCodecs, audio);
            transceiver.setCodecPreferences([...sendCodecs]);
        }
        if (kind === 'video') {
            sendCodecs = _preferCodec(sendCodecs, video);
            transceiver.setCodecPreferences([...sendCodecs]);
        }
    }
    catch (e) {
        console.log('Error at setting codecs, expected in Safari', e);
    }
    return transceiver;
}
function _preferCodec(codecs, mimeType) {
    const otherCodecs = [];
    const sortedCodecs = [];
    codecs.forEach((codec) => {
        if (codec.mimeType === mimeType) {
            sortedCodecs.push(codec);
        }
        else {
            otherCodecs.push(codec);
        }
    });
    return sortedCodecs.concat(otherCodecs);
}
function setAudioCodec(peerConnection, audioCodec) {
    const transceivers = peerConnection.getTransceivers();
    transceivers.forEach((transceiver) => {
        _setCodecs(transceiver, audioCodec);
    });
}
exports.setAudioCodec = setAudioCodec;
function setVideoCodec(peerConnection, videoCodec) {
    const transceivers = peerConnection.getTransceivers();
    transceivers.forEach((transceiver) => _setCodecs(transceiver, 'audio/opus', videoCodec));
}
exports.setVideoCodec = setVideoCodec;
// sets the default codecs on the PC, by default it
// sets audio/opus video/vp8
function setDefaultCodecs(peerConnection) {
    const transceivers = peerConnection.getTransceivers();
    transceivers.forEach((transceiver) => _setCodecs(transceiver));
}
exports.setDefaultCodecs = setDefaultCodecs;
